import CheckBox from '@app/components/CheckBox'
import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import MarkupText from '@app/components/MarkupText'
import SearchBar from '@app/components/SearchBar'
import { ITodo } from '@app/models/Todo'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Column } from 'react-virtualized'
import { actionCreators, ITodoListState } from '../modules/todoList'

type ComponentProps = ITodoListState & typeof actionCreators

export default class AssignmentsListPage extends React.PureComponent<
  ComponentProps
> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public render() {
    return (
      <DocumentTitle title='To Dos'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>My To Dos</h3>
            <SearchBar
              onChange={this._onChangeFilter}
              placeholder='Looking for something?'
              size='sm'
              className='mb-2'
              value={this.props.filterText}
            />
            <CheckBox
              onChange={(e) => {
                this.props.setShowCompleted(e)
                this._reloadData()
              }}
              value={this.props.showCompleted}
            >
              Show completed
            </CheckBox>
          </div>
          <div className='mt-4'>
            <InfiniteScrollTable
              isLoading={this.props.isLoading}
              items={this.props.items}
              rowHeight={50}
              loadItems={this.props.loadTodo}
              noRowsRenderer={this._noRowsRenderer}
              onRowClicked={this._onRowClicked}
              totalItems={this.props.totalItems}
              ref={this.tableRef}
            >
              <Column
                cellDataGetter={({ rowData }) => {
                  const todo = rowData as ITodo
                  return todo.title
                }}
                dataKey='title'
                flexGrow={1}
                label='Title'
                width={100}
              />
              <Column
                cellRenderer={({ rowData }) => {
                  const todo = rowData as ITodo
                  return <MarkupText text={todo.markup} />
                }}
                dataKey='details'
                flexGrow={1}
                label='Details'
                width={100}
              />
              <Column
                cellRenderer={({ rowData }) => {
                  const todo = rowData as ITodo
                  return (
                    <div className='btn-group'>
                      <div
                        className='mr-4'
                        onClick={(e) => {
                          // clicked edit ${todo.title}
                        }}
                      >
                        <FontAwesomeIcon
                          icon={['fal', 'pencil']}
                          color='#4267b2'
                        />
                      </div>
                      <div
                        onClick={(e) => {
                          // clicked delete ${todo.title}
                        }}
                      >
                        <FontAwesomeIcon
                          icon={['fal', 'trash']}
                          color='#D33921'
                        />
                      </div>
                    </div>
                  )
                }}
                dataKey='deleteButton'
                width={60}
              />
            </InfiniteScrollTable>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No todos</div>
  }

  private _onRowClicked(item: ITodo, index: number) {
    window.alert(`Clicked on ${item.title}`)
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
